import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActions, Typography, Button, CardHeader } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    "&:hover": {
      transform: 'scale(1.02)',
      WebkitTransform: 'scale(1.02)',
      boxShadow: "inset 0 0 0 2px",
      cursor: 'pointer'
    }
  },
  tourheaderbox: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  }
}));

const GiftCardAreaCard = props => {

  const { className, area } = props;
  const classes = useStyles();
  return (
    <div>
      <Card className={classes.card}>
        <CardHeader className={classes.tourheaderbox}
          title={area.AreaName}
          titleTypographyProps={{ color: "inherit" }}
        />
        <CardContent>
          <Typography component="p" color="textSecondary">
            <br />
            {area.DisplayText}
          </Typography>
        </CardContent>
        <CardActions>

          <Button variant="contained" onClick={() => props.callCalender(area)} color="primary">Buy Now</Button>
        </CardActions>
      </Card>
    </div>
  );
};

export default GiftCardAreaCard;
